<template>
	<BaseModal :title="t('WEBAPP_FILTERS')" :has-done-button="true" :closable="false" @dismiss="close">
		<FilterMenuContent :collectionType="collectionType" :currentFilters="currentFilters" />
	</BaseModal>
</template>

<script setup lang="ts">
import FilterMenuContent from '@/components/filter-bar/FilterMenuContent.vue';
import BaseModal from '@/components/modals/vfm/BaseModal.vue';
import { CollectionType } from '@/enums/collection-type';
import { VFMHelper } from '@/helpers/vfm/vfm-helper';
import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { computed } from 'vue';

const props = defineProps<{
	collectionType: CollectionType;
}>();

const filterStore = useFilterStore();
const languageStore = useLanguageStore();
const { t } = useI18n();

const currentFilters = computed(() => filterStore.filters(props.collectionType));

onMounted(languageStore.fetchLocales);

function close() {
	VFMHelper.closeById('filters');
}
</script>

<style lang="scss">
@import '~@/styles/variables.scss';

.filter-menu-modal {
	width: min(500px, calc(100vw - 41px)) !important;
	min-width: 320px !important;
	height: 100vh;
	max-width: 100%;
	border-radius: 0;

	section {
		flex-grow: 1;
	}
}
</style>
